import React from "react";
import { ReactComponent as PxLoading } from "../../img/prescription_loading.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {
  TableContainer,
  Table,
  TableBody,
  makeStyles,
  List,
  ListItem,
  ListItemText,
  Collapse,
} from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { getFormattedDate } from "./utils";
import PrescriptionView from "./prescriptionView";
import MedicinePx from "./medicinePx";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: "#f78f2d",
  },
  emptyStateText: {
    textAlign: "center",
    color: "#f78f2d",
  },
}));

const PreviousPx = ({ isLoading, patientPx }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const loadingView = () => (
    <div id="loading_content" className="loading_content text-center py-3">
      <p className="desc" style={{ textAlign: "center", margin: "auto" }}>
        {t("px.fetchingLatestPxMsg1")}
      </p>
      <p className="desc" style={{ textAlign: "center", margin: "auto" }}>
        {t("px.fetchingLatestPxMsg2")}
      </p>
      <div className="thumbnail" style={{ marginTop: "5em" }}>
        <PxLoading className="img-fluid" />
      </div>
    </div>
  );

  function HistoryRow(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    return (
      <>
        <List
          component="History"
          aria-labelledby="nested-list-subheader"
          className={classes.root}
        >
          <ListItem
            button
            onClick={() => {
              setOpen(!open);
            }}
          >
            <ListItemText primary={getFormattedDate(row.date)} />
            {open ? (
              <ExpandLess style={{ color: "#f6781b" }} />
            ) : (
              <ExpandMore style={{ color: "#f6781b" }} />
            )}
          </ListItem>

          <span className="divider" style={{ margin: 0 }}></span>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <div className="inner_body " style={{ marginTop: "1em" }}>
              <div id="test_content" className="animate-bottom">
                <div className="content_presc_row py-2">
                  <div className="inner_presc px-3 py-2">
                    <MedicinePx medicines={row.medicines} />
                  </div>
                </div>
                <div className="px-4">
                  <PrescriptionView px={row} />
                </div>
              </div>
            </div>
            <span className="divider"></span>
          </Collapse>
        </List>
      </>
    );
  }
  const pxView = (px) => {
    return px ? (
      <>
        {px.length !== 0 ? (
          <TableContainer>
            <Table aria-label="collapsible table">
              <TableBody>
                {px.map((row, index) => (
                  <HistoryRow key={index} row={row} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div className=" text-center py-3 px-3">
            <span
              className={classes.emptyStateText}
              style={{ textAlign: "center", margin: "auto" }}
            >
              {t("px.pxUnavailable")}
            </span>
          </div>
        )}
      </>
    ) : (
      <>Failed to load prescription</>
    );
  };

  return (
    <>
      <div id="lastestpx">
        {isLoading ? loadingView() : pxView(patientPx.history)}
      </div>
    </>
  );
};

export default PreviousPx;
